import styled, { css } from 'styled-components';
import { getTextColor, getBackgroundColor, color, themeGet } from '@magalu/stereo-ui-styles';
import { space } from 'styled-system';
import LinkComp from '../../atoms/Link';
import { fadeIn } from '../../utils';
export const NavMenuContainer = styled.nav.attrs(props => Object.assign({
  bg: 'background.primary'
}, props))`
  text-align: left;

  ${color}
`;
export const NavMenu = styled.ul.attrs(props => Object.assign({
  my: 0,
  pl: 0
}, props))`
  display: flex;
  align-items: center;
  line-height: 45px;
  list-style: none;
  white-space: nowrap;
  justify-content: space-between;

  ${space}
`;
export const Link = styled(LinkComp).attrs(props => Object.assign({
  color: 'text.white',
  px: '10px',
  underlineOnHover: false
}, props))`
  ${color}
`;
export const NavSubmenu = styled.div`
  position: absolute;
  background-color: ${props => getBackgroundColor('white')(props)};
  z-index: ${props => themeGet('zIndices.4')(props)};
  visibility: ${props => props.show ? 'visible' : 'hidden'};
  opacity: ${props => props.show ? 1 : 0};
  pointer-events: ${props => props.show ? 'auto' : 'none'};
  transition: opacity 0;
`;
export const NavMenuItem = styled.li`
  display: inline-block;
  position: relative;
  vertical-align: middle;
  justify-content: center;
  align-items: center;
  z-index: ${props => props.selected ? themeGet('zIndices.1')(props) : 'auto'};
  background-color: ${props => props.selected ? getBackgroundColor('white')(props) : 'transparent'};

  border-top-left-radius: ${props => props.selected ? '6px' : '0'};
  border-top-right-radius: ${props => props.selected ? '6px' : '0'};

  &:hover path {
    fill: ${props => props.colorOnHover || getTextColor('base')(props)};
  }

  &:hover > div > a {
    color: ${props => props.colorOnHover || getTextColor('base')(props)};
  }

  ${props => props.selected && css`
      & path {
        fill: ${props.colorOnHover || getTextColor('base')(props)} !important;
      }

      > div > a {
        color: ${props.colorOnHover || getTextColor('base')(props)} !important;
      }
    `}
`;
export const MenuOverlay = styled.div`
  background: rgba(0, 0, 0, 0.6);
  animation: ${fadeIn} 0.2s linear;

  position: fixed;
  z-index: ${props => themeGet('zIndices.0')(props)};
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  ${props => props.show ? css`
          display: block;
        ` : css`
          display: none;
        `};
`;